module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KLG13j/tc-custom/9781631940217.jpg?1726454432868",
      "alt": "This image is the cover for the book Night Walk, Henry Gamadge"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Night Walk, Henry Gamadge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From Agatha Christie’s favorite American author—a 1940s amateur sleuth must save a friend accused of murder in a small New York town.")]), _c('br'), _c('br'), _vm._v(" Frazer’s Mills, in Westchester County, New York, is a small, isolated village, where everyone knows everyone else and things haven’t changed much (and the mills have been closed for quite some time). When murder suddenly intrudes upon this sedate rural backwater, antiquarian book dealer Henry Gamadge arrives to solve the mystery and restore order."), _c('br'), _c('br'), _vm._v(" “One of Daly's best . . . an engrossing tale, both for its problem and for its setting.” —Curt Evans, "), _c('i', [_vm._v("The Passing Tramp")]), _vm._v(" blog\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Daly\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Felony & Mayhem Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0